import { initAppOnReady } from '../utils/appUtils';
import { renderIframeApp } from '../iframe/LiveChatIframeApp';
initAppOnReady(renderIframeApp);
